
  import { UserflowTriggers } from '@/services/userflow/userflow';
  import CreateHubspotTicketModal from '@/ui/components/resourceCenter/CreateHubspotTicketModal.vue';
  import { useWindowMessage } from '@/ui/concerns/useWindowMessage';
  import { defineComponent, ref } from 'vue';

  export default defineComponent({
    components: {
      CreateHubspotTicketModal,
    },
    setup() {
      const active = ref(false);

      const close = () => {
        active.value = false;
      };

      useWindowMessage(UserflowTriggers.OPEN_REPORT_ISSUE_MODAL, () => {
        active.value = true;
      });

      return {
        active,
        close,
      };
    },
  });
